<template>
  <v-app>
    <v-main>
      <centered-layout>
        <div class="text-center">
          <v-progress-circular color="primary" class="mb-4" indeterminate></v-progress-circular>
          <h1 class="title">Авторизуемся</h1>
        </div>
      </centered-layout>
    </v-main>
  </v-app>
</template>

<script>
import { ProcessMixin } from '@lib/vue-playrix-auth/mixins';

import CenteredLayout from './layouts/CenteredLayout.vue';

export default {
  metaInfo: {
    title: 'Авторизуемся',
  },
  mounted() {
    this.processAuth().catch(({ message }) => {
      this.$toast.error(`Ошибка авторизации: ${message}`);

      this.$router.push({ name: 'auth' }).catch(() => {});
    });
  },
  components: { CenteredLayout },
  mixins: [ProcessMixin],
};
</script>
